import React, { useState, useEffect } from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Table from 'react-bootstrap/Table';
import { listGuests } from '../../api/calls';
import '../CheckInModal/modalOverwrite.css';

const PAYMENT_OPTIONS = ['Cash', 'Square', 'Venmo', 'Guest Pass'];

const GuestModal = ({ show, onHide, member, onSave, userType }) => {
    const [guestName, setGuestName] = useState('');
    const [cellEmail, setCellEmail] = useState('');
    const [partySize, setPartySize] = useState(1);
    const [paymentMethod, setPaymentMethod] = useState('Cash');
    const [saving, setSaving] = useState(false);
    const [guestHistory, setGuestHistory] = useState([]);

    useEffect(() => {
        if (show && userType === 'manager' && member) {
            listGuests().then(all => {
                const filtered = all
                    .filter(g => g.member === member.PK && g.name)
                    .sort((a, b) => b.date - a.date);
                setGuestHistory(filtered);
            });
        }
    }, [show, member, userType]);

    const handleSave = async () => {
        setSaving(true);
        await onSave({
            guestName,
            cellEmail,
            partySize,
            paymentMethod,
            memberPK: member?.PK,
        });
        setSaving(false);
        handleClose();
    };

    const handleClose = () => {
        setGuestName('');
        setCellEmail('');
        setPartySize(1);
        setPaymentMethod('Cash');
        setGuestHistory([]);
        onHide();
    };

    const formatDate = (ts) => new Date(ts).toLocaleString();

    return (
        <Modal show={show} onHide={handleClose} dialogClassName="modal-90w" centered>
            <Modal.Header closeButton>
                <Modal.Title>Log Guest Entry</Modal.Title>
            </Modal.Header>
            <Modal.Body style={{ backgroundColor: '#f5f7fa' }}>
                {member && (
                    <p className="text-muted mb-3">
                        Sponsored by: {member.lastName}, {member.firstName}
                    </p>
                )}
                <Form>
                    <Row>
                        <Col>
                            <Form.Group>
                                <Form.Label>Guest Name</Form.Label>
                                <Form.Control
                                    type="text"
                                    placeholder="Enter guest name"
                                    value={guestName}
                                    onChange={e => setGuestName(e.target.value)}
                                />
                            </Form.Group>
                        </Col>
                        <Col>
                            <Form.Group>
                                <Form.Label>Cell/Email</Form.Label>
                                <Form.Control
                                    type="text"
                                    placeholder="Phone or email"
                                    value={cellEmail}
                                    onChange={e => setCellEmail(e.target.value)}
                                />
                            </Form.Group>
                        </Col>
                        <Col xs="auto">
                            <Form.Group>
                                <Form.Label>Party Size</Form.Label>
                                <Form.Control
                                    type="number"
                                    min={1}
                                    value={partySize}
                                    style={{ width: '80px' }}
                                    onChange={e => setPartySize(parseInt(e.target.value, 10) || 1)}
                                />
                            </Form.Group>
                        </Col>
                        <Col xs="auto">
                            <Form.Group>
                                <Form.Label>Payment Method</Form.Label>
                                <Form.Control
                                    as="select"
                                    value={paymentMethod}
                                    style={{ width: '140px' }}
                                    onChange={e => setPaymentMethod(e.target.value)}
                                >
                                    {PAYMENT_OPTIONS.map(opt => (
                                        <option key={opt} value={opt}>{opt}</option>
                                    ))}
                                </Form.Control>
                            </Form.Group>
                        </Col>
                    </Row>
                </Form>

                {userType === 'manager' && guestHistory.length > 0 && (
                    <>
                        <hr />
                        <p className="font-weight-bold mb-2">Previous Guest Entries</p>
                        <Table striped bordered size="sm">
                            <thead>
                                <tr>
                                    {['Date', 'Guest Name', 'Cell/Email', 'Party Size', 'Payment'].map(h => (
                                        <th key={h} style={{ backgroundColor: '#4a6fa5', color: '#fff', borderColor: '#3a5a8f' }}>{h}</th>
                                    ))}
                                </tr>
                            </thead>
                            <tbody>
                                {guestHistory.map(g => (
                                    <tr key={g.PK}>
                                        <td>{formatDate(g.date)}</td>
                                        <td>{g.name}</td>
                                        <td>{g.cellEmail || '—'}</td>
                                        <td>{g.guestCount}</td>
                                        <td>{g.payment}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </Table>
                    </>
                )}
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>Cancel</Button>
                <Button
                    variant="primary"
                    onClick={handleSave}
                    disabled={!guestName.trim() || saving}
                >
                    {saving ? 'Saving...' : 'Save'}
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default GuestModal;
